<template>
  <img src="@/assets/img/picture.png" alt="main picture"/>
</template>

<style lang="scss" scoped>
img {
  width: 100%;
  max-height: 800px;
}
</style>